<template>
	<cTable ref="table" :config="config" :fields="fields" :header="header" :methods="methods" :modals="modals">
	</cTable>
</template>

<script>
import {
	getList,
	detail,
	update,
	del,
	confirm,
	writeOff,
	exportData
} from "@/api/finance/storage_bill";
import { getAllClient, getCompanies } from "@/api/user/client";
import { getWarehouse } from "@/api/storage/warehouse";
import cTable from "@/base/common/index";
import { getKeysType, getSelectType } from "@/api/public";
import { getCurrency } from "@/api/finance/currency";
import toPage from "@/base/common/topage";

export default {
	name: "storageBill",
	mixins: [toPage],
	components: {
		cTable
	},
	props: {
		branch: {
			type: Boolean,
			default: false,
		}
	},
	data() {
		return {
			detailList: [],
			config: {},
			methods: {
				list: (params) => {
					if (this.branch) params.is_branch = 1
					else params.is_hq = 1
					return getList(params)
				},
				detail,
				update,
				del,
				confirm,
				writeOff,
				getAllClient,
				exportData,
				getCompanies
			},
			modals: {
				writeOff: {
					type: 'add',
					methods: {
						ok({ row, close }) {
							this.$page
								.handleRequestMethods("writeOff", row)
								.then((res) => {
									this.$Message["success"]({
										background: true,
										content: res.msg,
									});
									this.$page.getList();
									close();
								});
						},
					},
					config: {
						title: this.$t("writeOff"),
						modalBind: {
							width: 600,
							draggable: true,
						},
						formBind: {
							labelWidth: 100,
						},
						rowBind: {
							gutter: 16,
							style: {
								marginBottom: "20px",
							},
						},
						rules: {
							to_amount: [
								{
									required: true,
									message: this.$t("select") + this.$t("clientName"),
									type: 'number',

									trigger: "blur",
								},
							],
						},
					},
					grid: [
						{ to_amount: 24 },
						{ off_type: 24 },
						{ remarks: 24 },
					],
					fields: [
						{
							name: () => this.$t("reChAmount"),
							key: "to_amount",
							component: "InputNumber",
							placeholder: () => this.$t("enter") + this.$t("reChAmount"),
							bind: {
								style: 'width:100%'
							},
							default: 0,
						},
						{
							name: this.$tz('类型'),
							key: 'off_type',
							component: 'Radio',
							options: [
								{ label: this.$tz('线上'), value: 1 },
								{ label: this.$tz('线下'), value: 2 },
							],
							optionsFn: '',
							optionsKey: '',
							default: 1,
							bind: {
								border: true
							}
						},
						{
							key: 'remarks',
							name: () => this.$tz('备注'),
							placeholder() {
								return this.$tz('备注');
							},
							component: 'Input',
							bind: {
								type: 'textarea',
								autosize: { minRows: 3 },
							},
						},
					],
				},
				showDetails: {
					config: {
						listFn: 'detail',
						modalBind: {
							draggable: true,
							transfer: true,
							width: 1500,
						},
					},
					header: {
						show: () => true,
						btns: [
							{
								name: () => this.$t("export"),
								type: "export",
								fnName: "export",
								bind: {
									type: "primary"
								},
							},
						],
						methods: {
							export({ row }) {
								this.$page.handleRequestMethods('exportData', this.pageConfig.data.id, true, true).then(res => {
									window.open(this.$globalUrl + res.payload.src)
								})
							}
						}
					},
					table: {
						config: {
							height: 600,
						},
						fields: [
							{
								name: () => this.$t("orderNum"),
								key: "airway_number",
								minWidth: 130,
							},
							{
								name: () => this.$t("plan1"),
								key: "plan",
								minWidth: 130,
							},
							{
								name: () => this.$t("warehouseName2"),
								key: "warehouse",
								minWidth: 130,
							},
							{
								name: () => this.$t("reason_billing"),
								key: "cause",
								minWidth: 130,
							},
							{
								name: () => this.$t("billingStartTime"),
								key: "start_time",
								minWidth: 130,
							},
							{
								name: () => this.$t("billingEndTime"),
								key: "end_time",
								minWidth: 130,
							},
							{
								name: () => this.$t("currency_t"),
								key: "to_currency",
								minWidth: 130,
							},
							{
								name: () => this.$t("doublePrice"),
								key: "price",
								minWidth: 130,
							},
							{
								name: () => this.$t("total_amount"),
								key: "amount",
								minWidth: 130,
							},
							{
								name: () => this.$t("Remarks"),
								key: "remarks",
								minWidth: 130,
							}
						],
						footer: {
							show: () => true,
						}
					},
					footer: { show: () => false },
				},
				update: {
					methods: {
						ok({ row, close }) {
							this.$page
								.handleRequestMethods("update", row)
								.then((res) => {
									this.$Message["success"]({
										background: true,
										content: res.msg,
									});
									this.$page.getList();
									close();
								});
						},
					},
					config: {
						title: this.$t("update"),
						modalBind: {
							width: 600,
							draggable: true,
						},
						formBind: {
							labelWidth: 100,
						},
						rowBind: {
							gutter: 16,
							style: {
								marginBottom: "20px",
							},
						},
						rules: {
							bill_name: [
								{
									required: true,
									message: this.$t("select") + this.$t("clientName"),
									trigger: "blur",
								},
							],
						},
					},
					grid: [
						{ bill_name: 24 },
						{ to_rate: 24 },
						{ currency: 24 },
						{ remarks: 24 },
					],
					fields: [
						{
							name: () => this.$t("b2bName"),
							key: "bill_name",
							component: "Input",
							placeholder: () => this.$t("enter") + this.$t("b2bName"),
						},
						{
							name: () => this.$t("rate"),
							key: "to_rate",
							component: "Input",
							placeholder: () => this.$t("enter") + this.$t("rate"),
						},
						{
							name: this.$t("toCurrency"),
							key: "currency",
							component: "Select",
							placeholder: () => this.$t("select") + this.$t("toCurrency"),
							options: [],
							config: {
								label: "title",
								value: "code",
							},
							methods: {
								list({ field }) {
									getCurrency().then((res) => {
										if (res.data.status) {
											field.options = res.data.payload.rows;
										}
									});
								},
							},
						},
						{
							name: () => this.$t("Remarks"),
							key: "remarks",
							component: "Input",
							placeholder: () => this.$t("enter") + this.$t("Remarks"),
							bind: {
								rows: 5,
								type: "textarea",
							},
						},
					],
				},
			},
			header: {
				searchs: [

					{
						key: "keywords",
						placeholder() {
							return this.$t("keyword");
						},
						component: "Input",
						bind: {
							type: "textarea",
							rows: 1
						}
					},
					{
						key: "target_type",
						component: "Select",
						placeholder: () => this.$t("select") + this.$t("CollectionUser"),
						clearable: true,
						options: [
							{ label: this.$t("b2bClient"), value: 1 },
							{ label: this.$t("branchOffice"), value: 2 },
						],
						show: () => !this.branch
					},
					{
						name: () => this.$t("ownership"),
						key: "ownership",
						component: "Select",
						placeholder() {
							return this.$t("select") + this.$t("ownership");
						},
						show: () => !this.branch,
						options: [],
						config: { label: "title", value: "id" },
						methods: {
							async list({ field }) {
								field.options = (
									await this.$page.handleRequestMethods("getCompanies")
								).payload;
								this.$forceUpdate();
							},
						},
					},
					{
						key: "client_id",
						placeholder() {
							return this.$t("select") + this.$t("clientName");
						},
						component: "Select",
						config: {
							value: "id",
							label: "account"
						},
						methods: {
							async list({ field }) {
								field.options = (
									await this.$page.handleRequestMethods("getAllClient")
								).payload.rows;
								this.$forceUpdate();
							}
						}
					},
					{
						key: "status",
						placeholder() {
							return this.$t("select") + this.$t("bill_type");
						},
						component: "Select",
						options: [],
						methods: {
							async list({ field }) {
								field.options = (await getSelectType('BILL_STATUS_TYPE')).data.payload['BILL_STATUS_TYPE']
							}
						}
					},
					{
						key: "dateType",
						placeholder() {
							return this.$t("select") + this.$t("timeType");
						},
						component: "Select",
						options: [],
						methods: {
							async list({ field }) {
								field.options = (await getSelectType('BILL_TIME_TYPE')).data.payload['BILL_TIME_TYPE']
							}
						}
					},
					{
						key: "startTime",
						placeholder() {
							return this.$t("select") + this.$t("start") + this.$t("date");
						},
						component: "DatePicker",
						bind: {
							options: {
								disabledDate(time) {
									return time.getTime() > Date.now();
								},
							},
							style: {
								width: "150px",
							},
						},
					},
					{
						key: "endTime",
						placeholder() {
							return this.$t("select") + this.$t("end") + this.$t("date");
						},
						component: "DatePicker",
						bind: {
							options: {
								disabledDate(time) {
									return time.getTime() > Date.now();
								},
							},
							style: {
								width: "150px",
							},
						},
					},
				],
				btns: {
					list: [
						{
							name: () => this.$t("export"),
							type: "export",
							fnName: "export",
							bind: {
								type: "primary"
							},
							disabled() {
								return !this.selectAll.length;
							}
						},
						{
							name: () => this.$t("createBill"),
							type: "create",
							fnName: "create",
							bind: {
								type: "primary",
							},
							id: 1549,
						},
					],
					methods: {
						create({ searchForm }) {
							// let ids = this.selectAll.map(t=>t.id)
							this.getModal("create_bill").open();
						},
						export() {
							this.exportExc();
						}
					}
				}
			},
			fields: [
				{
					type: "checkbox",
					align: "center",
					width: 60
				},
				{
					name: () => this.$t("codNAme"),
					key: "bill_name",
					minWidth: 130,

				},
				{
					name: () => this.$t("bill_number"),
					key: "bill_number",
					minWidth: 180,
					component: 'Button',
					bind: {
						size: 'small',
						type: 'primary'
					},
					methods: {
						click({ row }) {
							this.$page.getModal('showDetails').open({
							}, function () {
								this.pageConfig.data.id = row.id
								this.setTitle(row.bill_number)
								this.getList()
							})
						}
					}
				},
				{
					name: () => this.$t("bill_type"),
					key: "status_name",
					minWidth: 130,
				},
				{
					name: () => this.$t("CollectionUser"),
					key: "target",
					minWidth: 100,
					show: () => !this.branch
				},
				{
					name: () => this.$t("clientName"),
					key: "account",
					minWidth: 130,
				},
				{
					name: () => this.$t("shipper_company_cn"),
					key: "company",
					minWidth: 130,
				},
				{
					name: () => this.$t("preferential"),
					key: "contract",
					minWidth: 100,
				},
				{
					name: () => this.$t("bill1"),
					children: [
						{
							name: () => this.$t("currency_t"),
							key: "to_currency",
							minWidth: 130,
						},
						{
							name: () => this.$t("rate"),
							key: "to_rate",
							minWidth: 130,
						},
						{
							name: () => this.$t("reChAmount"),
							key: "to_amount",
							minWidth: 130,
						},
					],
				},
				{
					name: () => this.$t("business"),
					key: "sale_name",
					minWidth: 130,
				},
				{
					name: () => this.$t("createTime"),
					key: "create_time",
					minWidth: 130,
				},
				{
					name: () => this.$t("createUser"),
					key: "create_name",
					minWidth: 130,
				},
				{
					name: () => this.$t("confirm_time"),
					key: "confirm_time",
					minWidth: 130,
				},
				{
					name: () => this.$t("check_time"),
					key: "write_off_time",
					minWidth: 130,
				},
				{
					name: this.$t("operation"),
					type: "btns",
					width: 300,
					fixed: "right",
					// width({ field }) {
					//   return field.list.length * 40 + 40;
					// },
					list: [
						{
							name: () => this.$t("update"),
							type: "update",
							fnName: "update",
							bind: {
								type: "primary"
							},
							disabled: ({ row }) => row.status != 1
						},
						{
							name: () => this.$t("confirm"),
							type: "confirm",
							fnName: "confirm",
							bind: {
								type: "success"
							},
							show: ({ row }) => row.status == 1
						},
						{
							name: () => this.$t("Cancel Confirm"),
							type: "confirm",
							fnName: "confirm",
							bind: {
								type: "success"
							},
							show: ({ row }) => row.status == 4
						},
						{
							name: () => this.$t("writeOff"),
							type: "writeOff",
							fnName: "writeOff",
							bind: {
								type: "primary"
							},
							disabled: ({ row }) => row.status < 1 || row.status >= 9
						},
						{
							name: () => this.$t("delete"),
							type: "delete",
							fnName: "delete",
							bind: {
								type: "error"
							},
							disabled: ({ row }) => row.status != 1
						},
					],
					methods: {
						writeOff({ row }) {
							this.getModal('writeOff').open(row, function () {
								this.setTitle(this.$t("confirm") + `(${row.bill_number})`)
							})
						},
						update({ row }) {
							this.getModal('update').open(row, function () {
								this.setTitle(this.$t("update") + `(${row.bill_number})`)
							})
						},
						confirm({ row }) {
							this.$Modal.confirm({
								title: this.$t("confirm") + `(${row.bill_number})`,
								width: 300,
								content: this.$t("titleModal"),
								onOk: () => {
									this.handleRequestMethods("confirm", row, true, true).then(() => this.getList());
								}
							});
						},
						delete({ row }) {
							this.$Modal.confirm({
								title: this.$t("delete") + `(${row.bill_number})`,
								width: 300,
								content: this.$t("titleModal"),
								onOk: () => {
									this.handleRequestMethods("del", row, true, true).then(() => this.getList());
								}
							});
						},
					}
				}
			]
		};
	}
};
</script>
